export enum PromotionMessage {
  RegularCustomerSpecialWithoutFullPrice = 1,
  FullPriceWithoutRegularCustomerSpecial,
  NonQualifyingPurchaseCustomerSpecial,
  BuyOneGetOne50,
  NonQualifyingPurchaseCollectAndSave = 5,
  SurpriseBuyProgram = 6,
}
